export const FETCH_PROGRAMS_SUCCESS = 'FETCH_PROGRAMS_SUCCESS';
export const FETCH_PROGRAMS_ERROR = 'FETCH_PROGRAMS_ERROR';

export const FETCH_PROGRAM_SUCCESS = 'FETCH_PROGRAM_SUCCESS';
export const FETCH_PROGRAM_ERROR = 'FETCH_PROGRAM_ERROR';

export const CREATE_PROGRAM_SUCCESS = 'CREATE_PROGRAM_SUCCESS';
export const CREATE_PROGRAM_ERROR = 'CREATE_PROGRAM_ERROR';

export const DELETE_PROGRAM_SUCCESS = 'DELETE_PROGRAM_SUCCESS';
export const DELETE_PROGRAM_ERROR = 'DELETE_PROGRAM_ERROR';

export const UPDATE_PROGRAM_SUCCESS = 'UPDATE_PROGRAM_SUCCESS';
export const UPDATE_PROGRAM_ERROR = 'UPDATE_PROGRAM_ERROR';

export const ON_CHANGE_NAME_PROGRAM = 'ON_CHANGE_NAME_PROGRAM';

export const RESET_MESSAGE = 'RESET_MESSAGE';

export const RESET_CURRENT_PROGRAM = 'RESET_CURRENT_PROGRAM';
